<template>
  <div>
    <hr />
    <div class="flex-1 jbet">
      <div>
        <label class="col-form-label font-weight-bold"> Comprimento *</label>
        <div class="flex-row">
          <!-- <input v-maska="['#.###', '']" class="form-control p-3" v-model="dados.Comprimento" placeholder="mm"  > -->
          <input v-model="v$.dados.Comprimento.$model" v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
            placeholder="mm" :class="['form-control', { error: v$.dados.Comprimento.$error }]"
            :disabled="configInputs" />
          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>

        <div class="text-red" v-if="v$.dados.Comprimento.$error">
          O campo Comprimento é obrigatório.
        </div>
      </div>

      <div>
        <label class="col-form-label font-weight-bold"> Largura *</label>
        <div class="flex-row">
          <input min="0" v-model="v$.dados.Largura.$model"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="mm"
            :class="['form-control', { error: v$.dados.Largura.$error }]" :disabled="configInputs" />
          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>

        <div class="text-red" v-if="v$.dados.Largura.$error">
          O campo Largura é obrigatório.
        </div>
      </div>

      <div>
        <label class="col-form-label font-weight-bold"> Altura *</label>
        <div class="flex-row">
          <input min="0" v-model="v$.dados.Altura.$model"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="mm"
            :class="['form-control', { error: v$.dados.Altura.$error }]" :disabled="configInputs" />
          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>
        <div class="text-red" v-if="v$.dados.Altura.$error">
          O campo Altura é obrigatório.
        </div>
      </div>

      <div>
        <label class="col-form-label font-weight-bold"> Peso Aproximado *</label>
        <div class="flex-row">
          <input min="0" v-model="v$.dados.Peso_Aproximado.$model"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="Kg" :class="[
              'form-control',
              { error: v$.dados.Peso_Aproximado.$error },
            ]" :disabled="configInputs" />

          <span class="input-group-text" id="addon-wrapping">kg</span>
        </div>
        <div class="text-red" v-if="v$.dados.Peso_Aproximado.$error">
          O campo Peso Aproximado é obrigatório.
        </div>
      </div>
    </div>

    <div class="flex-1 jbet">
      <div>
        <label class="col-form-label font-weight-bold">
          Anel de Centragem *
        </label>
        <div class="flex-row">
          <input min="0" v-model="v$.dados.Anel_de_Centragem.$model"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="mm" :class="[
              'form-control',
              { error: v$.dados.Anel_de_Centragem.$error },
            ]" :disabled="configInputs" />

          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>
        <div class="text-red" v-if="v$.dados.Anel_de_Centragem.$error">
          O campo Anel de Centragem é obrigatório.
        </div>
      </div>

      <div>
        <label class="col-form-label font-weight-bold">
          Furo da Bucha de Injeção
        </label>
        <div class="flex-row">
          <input min="0" v-model="v$.dados.Bucha_de_Injecao.$model"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="mm" :class="[
              'form-control',
              { error: v$.dados.Bucha_de_Injecao.$error },
            ]" :disabled="configInputs" />

          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>
        <div class="text-red" v-if="v$.dados.Bucha_de_Injecao.$error">
          O campo Anel de Centragem é obrigatório.
        </div>
      </div>

      <div>
        <label class="col-form-label font-weight-bold"> Raio da Bucha </label>
        <div class="flex-row">
          <input min="0" v-model="v$.dados.Raio.$model" v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']"
            placeholder="mm" :class="['form-control', { error: v$.dados.Raio.$error }]" :disabled="configInputs" />
          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>
        <div class="text-red" v-if="v$.dados.Raio.$error">
          O campo Raio é obrigatório.
        </div>
      </div>

      <div>
        <label class="col-form-label font-weight-bold">
          Refrigeração(Lado Movel)
        </label>
        <input v-maska="['##/##', '']" class="form-control-2 p-3" v-model="dados.Refrigeracao"
          placeholder="Entrada / Saída" :disabled="configInputs" />
      </div>
    </div>

    <div class="flex-1">
      <div>
        <label class="col-form-label font-weight-bold"> Refrigeração(Lado Fixo) </label>
        <div class="flex-row">
          <input min="0" v-model="dados.LadoFixo" v-maska="['##/##', '']" placeholder="Entrada / Saída"
            class="form-control-2 p-3" :disabled="configInputs" />
        </div>
        <!-- <div class="text-red" v-if="v$.dados.LadoFixo.$error">
          O campo Lado Fixo é obrigatório.
        </div> -->
      </div>

      <div>
        <label class="col-form-label font-weight-bold">Refrigeração(Gavetas) </label>
        <div class="flex-row">
          <input min="0" v-model="dados.Gavetas" v-maska="['##/##', '']" placeholder="Entrada / Saída"
            class="form-control-2 p-3" :disabled="configInputs" />

        </div>
        <!-- <div class="text-red" v-if="v$.dados.Gavetas.$error">
          O campo Gavetas é obrigatório.
        </div> -->
      </div>

      <div class="inputsRadio">
        <label class="col-form-label font-weight-bold">Tipos de Moldes *</label>

        <div class="inputRadio">
          <input :disabled="configInputs" type="radio" v-model="v$.dados.opcao_tipo_molde.$model" name="opcao"
            :value="2" selected />
          <label class="col-form-label font-weight-bold"> 2 Placas </label>
          <input :disabled="configInputs" type="radio" v-model="v$.dados.opcao_tipo_molde.$model" name="opcao"
            :value="3" />
          <label class="col-form-label font-weight-bold"> 3 Placas </label>
        </div>
        <div class="text-red" v-if="v$.dados.opcao_tipo_molde.$invalid">
          Opção de Tipo de Molde é obrigatório.
        </div>
      </div>
    </div>
    <div class="flex-1">
      <div class="inputsRadio">
        <label class="col-form-label font-weight-bold">
          Sistema de Extração *
        </label>

        <div class="inputRadio">
          <input v-model="dados.watHidra" type="checkbox" :disabled="configInputs" />
          <label class="col-form-label font-weight-bold"> Hidráulico </label>
          <input v-model="dados.watPne" type="checkbox" :disabled="configInputs" />
          <label class="col-form-label font-weight-bold"> Pneumático </label>
          <input v-model="dados.watMec" type="checkbox" :disabled="configInputs" />
          <label class="col-form-label font-weight-bold"> Mecânico </label>
        </div>
      </div>

      <div class="m-25">
        <label class="col-form-label font-weight-bold"> Curso Extrator *</label>
        <div class="flex-row">
          <input min="0" :disabled="configInputs" v-model="v$.dados.cursor_extrator.$model"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="mm" :class="[
              'form-control',
              { error: v$.dados.cursor_extrator.$error },
            ]" />
          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>
        <div class="text-red" v-if="v$.dados.cursor_extrator.$error">
          O campo Curso Extrator é obrigatório.
        </div>
      </div>

      <div class="m-25">
        <label class="col-form-label font-weight-bold">
          Layout de Extração *

        </label>
        <div class="flex-row">
          <select v-model="v$.dados.layout_extracao.$model" :disabled="configInputs" :class="[
            'form-control',
            { error: v$.dados.layout_extracao.$error },
          ]">

            <option v-for="l in lista" :key="l.ID" :value="l.ID">
              {{ l.DESC_LAYOUT }}
            </option>
          </select>
          <span v-if="layoutSelecionado && layoutSelecionado.PATH_LAYOUT" @click="preview()" class="input-group-text"><i
              class="fas fa-eye"></i></span>
        </div>
        <div class="text-red" v-if="v$.dados.layout_extracao.$error">
          O campo Layout de Extração é obrigatório.
        </div>
      </div>
    </div>

    <div class="flex-1">
      <div>
        <label class="col-form-label font-weight-bold">
          Distância entre os furos
        </label>
        <div class="flex-row">
          <input min="0" :disabled="configInputs" v-model="dados.distancia_furos" class="form-control-2 p-3"
            placeholder="Ex: 100x200" />

          <!--  <span class="input-group-text" id="addon-wrapping">mm</span>-->
        </div>
        <!-- <div class="text-red" v-if="v$.dados.distancia_furos.$error">
          O campo Distância entre os furos é obrigatório.
        </div> -->
      </div>

      <div>
        <label class="col-form-label font-weight-bold"> Diâmetro </label>
        <div class="flex-row">
          <input min="0" :disabled="configInputs" v-model="dados.diametro"
            v-maska="['#####.##', '####.##', '###.##', '##.##', '#.##', '#']" placeholder="mm" class="form-control" />
          <span class="input-group-text" id="addon-wrapping">mm</span>
        </div>
        <!-- <div class="text-red" v-if="v$.dados.diametro.$error">
          O campo Diâmetro é obrigatório.
        </div> -->
      </div>

      <div class="inputsRadio">
        <label class="col-form-label font-weight-bold">
          Possui Câmara Quente ?
        </label>

        <div class="inputRadio">
          <label class="col-form-label font-weight-bold inputC">
            <input type="radio" v-model="dados.camera_quente.showCameraQuente" name="opcaoCameraQuente" :value="true"
              :disabled="configInputs" @click="camara = true" />
            Sim
          </label>

          <label class="col-form-label font-weight-bold inputC">
            <input type="radio" v-model="dados.camera_quente.showCameraQuente" name="opcaoCameraQuente" :value="false"
              :disabled="configInputs" @click="camara = false" checked />
            Não
          </label>

        </div>
      </div>
    </div>

    <div>
      <div v-show="dados.camera_quente.showCameraQuente">
        <div>
          <hr />
          <div class="main-cq">
            <h3 class="text-center text-success font-weight-bold md-3">
              Câmara Quente
              <i class="fas fa-thermometer-three-quarters" aria-hidden="true"></i>
            </h3>

            <div class="flex-row-2">
              <div class="m-40">
                <label class="col-form-label font-weight-bold"> ID </label>
                <input :disabled="configInputs" v-model="dados.camera_quente.id" type="text"
                  class="form-control-2 p-3" />
              </div>

              <div class="m-40">
                <label class="col-form-label font-weight-bold">
                  Número de Zonas:
                </label>
                <input :disabled="configInputs" v-model="dados.camera_quente.n_zonas" v-maska="['###', '']"
                  class="form-control-2 p-3" />
              </div>

              <div class="m-40">
                <label class="col-form-label font-weight-bold">
                  Fabricante:
                </label>
                <input :disabled="configInputs" v-model="dados.camera_quente.fabricante" type="text"
                  class="form-control-2 p-3" />
              </div>

              <div class="m-40">
                <label class="col-form-label font-weight-bold">
                  Tipo Termopar:
                </label>
                <input :disabled="configInputs" v-model="dados.camera_quente.tipo_termopar" type="text"
                  class="form-control-2 p-3" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <hr />

    <div class="">
      <h3 class="text-center text-success font-weight-bold md-3">
        Check-List da Engenharia / Ferramentaria
        <i class="fas fa-clipboard-check" aria-hidden="true"></i>
      </h3>

      <br />

      <div class="card shadow mb-4">
        <div class="card-body">
          <ChecklistSlot :configInputs="configInputs" @setDataCheckli3st="getDataChecklist" />
        </div>
      </div>
    </div>
    <div>
      <hr />

      <div class="
          flex-direction-column
          align-items-flex-start
          justify-content-center
          m-100
          gap
          text
        ">
        <div style="width: 100%">
          <label class="col-form-label font-weight-bold">
            Comentários Molde Fechado:
          </label>
          <textarea v-model="dados.comentario" class="form-control-2 p-3" rows="5" cols="50"
            placeholder="Só pode ser usado 500 caracteres..." maxlength="500" :disabled="configInputs"
            style="resize: none">
          </textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InputPersonMM from "../../../../../Inputs-defaults/Inp-Person-1.vue";
import Input_1 from "../../../../../Inputs-defaults/Inp-1.vue";
import InputRadios from "../../../../../Inputs-defaults/Inp-radius-emit .vue";
import InputCheckbox from "../../../../../Inputs-defaults/Inp-checkbox-emit .vue";
import InputSelect from "../../../../../Inputs-defaults/Inp-Select-emit.vue";
import ChecklistSlot from "../../../../../Tables/ChecklistSlot.vue";
import useVuelidate from "@vuelidate/core";
import { required, minLength, minValue, numeric, between } from "@vuelidate/validators";
import { GetDataAllLayout } from "../../../../../../controllers/LayoutExtrcao/GetDataAllLayout";
export default {
  components: {
    InputPersonMM,
    Input_1,
    InputRadios,
    InputCheckbox,
    InputSelect,
    ChecklistSlot,
  },
  props: {
    configInputs: Number,
  },
  async created() {
    const resp = await GetDataAllLayout();
    if (resp != undefined) {
      this.lista = resp.data.list;
    }
    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
    }
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      camara: false,
      sisextra: Object,
      tipomolde: Number,
      opcao: Boolean,
      opcao_cq: false,
      showCameraQuente: false,
      watHidra: Boolean,
      watPne: Boolean,
      watMec: Boolean,
      lista: [],

      dados: {
        Comprimento: "",
        Largura: "",
        Altura: "",
        Peso_Aproximado: "",
        Anel_de_Centragem: "",
        Bucha_de_Injecao: "",
        Raio: "",
        Refrigeracao: "",
        LadoFixo: "",
        Gavetas: "",
        opcao_tipo_molde: Number,
        watHidra: false,
        watPne: false,
        watMec: false,
        cursor_extrator: "",
        layout_extracao: "",
        distancia_furos: "",
        diametro: "",
        camera_quente: {
          showCameraQuente: false,
          id: "",
          n_zonas: "",
          fabricante: "",
          tipo_termopar: "",
        },
        checklist: Object,
        comentario: "",
      },
    };
  },
  computed: {
    layoutSelecionado() {
      return this.lista.find((l) => l.ID === this.dados.layout_extracao);
    },
  },
  validations() {
    return {
      dados: {
        Comprimento: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Largura: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Altura: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Peso_Aproximado: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Anel_de_Centragem: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Bucha_de_Injecao: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        Raio: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        // LadoFixo: {
        //   required,
        //   numeric,
        //   minValueValue: minValue(1),
        // },
        // Gavetas: {
        //   required,
        //   numeric,
        //   minValueValue: minValue(1),
        // },
        opcao_tipo_molde: {
          required,
          betweenValue: between(2, 3),
        },
        cursor_extrator: {
          required,
          numeric,
          minValueValue: minValue(1),
        },
        layout_extracao: {
          required,
        },
        // distancia_furos: {
        //   required,
        //   numeric,
        //   minValueValue: minValue(1),
        // },
        // diametro: {
        //   required,
        //   numeric,
        //   minValueValue: minValue(1),
        // },
      },
    };
  },

  methods: {
    preview() {
      this.$swal.fire({
        imageUrl:
          `${this.$store.state.ImgURL}layout_extracao/` +
          `${this.layoutSelecionado.PATH_LAYOUT}`,
        imageWidth: 700,
        imageHeight: 400,
        imageAlt: "Custom image",
      });
    },
    getObjExt(payload) {
      this.sisextra = payload;
    },
    getRaioSelect(payload) {
      this.tipomolde = payload;
    },

    getRaioShowCQ(payload) {
      if (payload == "true") {
        this.showCameraQuente = true;
      } else {
        this.showCameraQuente = false;
      }
    },
    async getDataChecklist(payload) {
      this.dados.checklist = payload;
    },

    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.MoldeFechado) {
        this.dados.Comprimento = dataQuery.MoldeFechado[0].COMPRIMENTO_MOLDE;
        this.dados.Largura = dataQuery.MoldeFechado[0].LARGURA_MOLDE;
        this.dados.Altura = dataQuery.MoldeFechado[0].ALTURA_MOLDE;
        this.dados.Peso_Aproximado = dataQuery.MoldeFechado[0].PESO_MOLDE;
        this.dados.Anel_de_Centragem = dataQuery.MoldeFechado[0].ANEL_CENTRAGEM;
        this.dados.Bucha_de_Injecao =
          dataQuery.MoldeFechado[0].BUCHA_DE_INJECAO;
        this.dados.Raio = dataQuery.MoldeFechado[0].RAIO_MOLDE;
        this.dados.Refrigeracao = dataQuery.MoldeFechado[0].REFRIGERACAO;
        this.dados.LadoFixo = dataQuery.MoldeFechado[0].LADO_FIXO;
        this.dados.Gavetas = dataQuery.MoldeFechado[0].GAVETAS;
        this.dados.opcao_tipo_molde = dataQuery.MoldeFechado[0].TIPO_DE_MOLDE;
        this.dados.watHidra = dataQuery.MoldeFechado[0].SISTEMA_DE_EXTRACAO_HID;
        this.dados.watPne = dataQuery.MoldeFechado[0].SISTEMA_DE_EXTRACAO_PNE;
        this.dados.watMec = dataQuery.MoldeFechado[0].SISTEMA_DE_EXTRACAO_MEC;
        this.dados.cursor_extrator = dataQuery.MoldeFechado[0].CURSOR_EXTRATOR;
        this.dados.layout_extracao = dataQuery.MoldeFechado[0].ID_LAYOUT;
        this.dados.distancia_furos = dataQuery.MoldeFechado[0].DIST_FUROS;
        this.dados.diametro = dataQuery.MoldeFechado[0].DIAMETRO;
        this.dados.camera_quente.showCameraQuente = JSON.parse(
          dataQuery.MoldeFechado[0].CAMARA_QUENTE
        );
        this.dados.camera_quente.id = dataQuery.MoldeFechado[0].CQ_ID;
        this.dados.camera_quente.n_zonas = dataQuery.MoldeFechado[0].CQ_N_ZONAS;
        this.dados.camera_quente.fabricante =
          dataQuery.MoldeFechado[0].CQ_FABRICANTE;
        this.dados.camera_quente.tipo_termopar =
          dataQuery.MoldeFechado[0].CQ_TIPO_TERMOPAR;
        this.dados.comentario = dataQuery.MoldeFechado[0].COMENTARIO;
      }
    },
  },

  watch: {
    camara(newValue) {
      this.$emit("dataCamara", newValue)

    },
    dados: {
      deep: true, // detectar mudanças aninhadas em objetos
      immediate: true, // acionando o manipulador imediatamente com o valor atual
      handler(newValue, oldValue) {
        this.$emit("dataMoldeFechado", newValue);
      },
    },
  },
};
</script>

<style scoped>
input:disabled,
select:disabled,
textarea:disabled {
  background: #66666621;
}

.inputC {
  display: flex;
  align-items: center;
}

.text {
  display: flex;
  width: 100%;
}

textarea {
  width: 100%;
}

.flex-1 {
  width: 100%;
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.jbet {
  justify-content: space-between;
}

.m-15 {
  width: 15%;
}

.m-25 {
  width: 25%;
}

.m-40 {
  width: 40%;
}

/* Input */

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.275rem 0.4rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  /* color: #212529; */
  text-align: center;
  white-space: nowrap;
  color: var(--white);
  background-color: var(--green);
  /* border: 1px solid #ced4da; */
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  border-right: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-left: none;
}

.flex-row {
  display: flex;
}

.flex-row select.form-control {
  min-width: 0;
  flex: 1 1 auto;
  text-overflow: ellipsis;
}

.flex-row .input-group-text {
  flex-shrink: 0;
  cursor: pointer;
}

.flex {
  flex-direction: column;
}

.flex-cq {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: 0.8rem !important;
  line-height: 1.5;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;

  border: 1px solid var(--greyBtn);

  border-radius: 0.35rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-control-2 {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--gray_text);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.flex-row:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderGreen);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}

.flex-row:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--borderGreen);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.form-control:focus {
  animation: pulseGreenShadow 0.5s ease-in-out infinite alternate-reverse;
}

.col-form-label {
  padding-top: calc(0.375rem + 1px);
  padding-bottom: calc(0.375rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.main-cq {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.flex-row-2 {
  margin-top: 10px;
  display: flex;
  gap: 20px;
}

textarea.form-control-2 {
  height: auto;
}

.form-control-2 {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid var(--gray_text);
  border-radius: 0.35rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.justify-content-center {
  align-items: center;
  justify-content: center;
  display: flex;
}

.align-items-flex-start {
  align-items: flex-start;
  justify-content: center;
  display: flex;
}

.flex-direction-column {
  display: flex;
  flex-direction: column;
}

.align-items-center {
  align-items: center;
}

.flex-row {
  display: flex;
}

.flex {
  flex-direction: column;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid var(--cinza);
  border-radius: 0.35rem;
}



.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.error {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--inputColor);
  background: var(--redTransparent);

  background-clip: padding-box;
  border-left: 1px solid var(--greyBtn);
  border-bottom: 1px solid var(--greyBtn);
  border-top: 1px solid var(--greyBtn);
  border-right: none;

  /* border-radius: 0.35rem; */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.text-red {
  color: var(--redTransparent);
  font-size: 12px;
  margin-top: 2px;
}

.error:focus {
  color: var(--inputColor);
  background-color: var(--white);
  border-color: var(--red);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgb(9 243 107 / 25%);
}

.valid {
  border-color: var(--green);
  background: var(--white);
}

.valid:focus {
  outline-color: var(--green);
}

.inputsRadio {
  width: 45%;
  display: flex;
  flex-direction: column;
}

.inputRadio {
  width: 100%;
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

@media (max-width: 1024px) {
  .inputsRadio {
    width: 50%;
  }

  .inputRadio {
    gap: 0.8rem;
  }
}

@media (max-width: 425px) {

  .flex-1,
  .flex-row-2 {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
  }

  .flex-row-2 div {
    width: 100%;
  }

  select .form-control {
    width: 100%;
  }

  .card {
    overflow-x: scroll;
  }

  .m-25 {
    width: 100%;
  }

  .inputsRadio {
    width: 100%;
  }

  .input-group-text {
    width: 15%;
    justify-content: center;
  }
}

@media (max-width: 320px) {
  .inputRadio {
    gap: 1.5rem;
  }
}
</style>
